import { useEffect, useState } from "react";
import { Button, Col, Form, Input, Row } from "antd";
import { t } from "i18next";
import ApiService from "../../core/service/api-service";
import { loadBranding } from "../../core/service/branding-service";

const { TextArea } = Input;

/**
 * Footer'daki WhatsApp destek butonunun ayarları. Marka kaydıyla aynı satırda (branding) tutulur;
 * kayıt son yüklenen ayarların üzerine yapılır ki marka alanları boşalmasın.
 */
export default function WhatsAppSettingsPanel()
{
    const [form] = Form.useForm();
    const [settings, setSettings] = useState({});
    const [loading, setLoading] = useState(false);

    const load = async () => {
        const res = await ApiService.Branding.GetSettings();
        if (!res?.success) return;

        setSettings(res.data);
        form.setFieldsValue({
            supportWhatsApp: res.data.supportWhatsApp,
            supportCategories: res.data.supportCategories,
        });
    };

    useEffect(() => {
        load();
    }, []);

    const save = async (values) => {
        setLoading(true);
        const res = await ApiService.Branding.SaveSettings({ ...settings, ...values });
        setLoading(false);
        if (res?.success) {
            await load();
            await loadBranding();
        }
    };

    return (
        <Form form={form} layout="vertical" onFinish={save}>
            <Row gutter={16}>
                <Col xs={24} md={12}>
                    <Form.Item
                        label={t("WhatsApp number")}
                        name="supportWhatsApp"
                        extra={t("With country code, e.g. 905xxxxxxxxx. Leave empty to hide the support button.")}
                    >
                        <Input placeholder="905xxxxxxxxx" />
                    </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                    <Form.Item
                        label={t("Categories")}
                        name="supportCategories"
                        extra={t("One category per row.")}
                    >
                        <TextArea rows={6} />
                    </Form.Item>
                </Col>
            </Row>

            <Button type="primary" htmlType="submit" loading={loading}>
                {t("Save")}
            </Button>
        </Form>
    );
}
